import React from "react";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from 'react-slick';

import "./CustomSlider.module.css";

import { SlArrowRight , SlArrowLeft} from "react-icons/sl";

function SampleNextArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div onClick={onClick}>
          <SlArrowRight className={`arrow ${className}`} size={20} style={{...style, color:"black"}}/>
    </div>
  );
}

function SamplePrevArrow(props: any) {
  const { className, style, onClick } = props;
  return ( 
    <div onClick={onClick}>
          <SlArrowLeft className={`arrow ${className}`} size={20} style={{...style, color:"black"}}/>
    </div>
  );
}

export default function CustomSlider({ elements }: { elements: JSX.Element[] }) {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplaySpeed: 4000,
        adaptiveHeight: true,
        autoplay: true,
        initialSlide: 0,
        prevArrow: <SamplePrevArrow/>,
        nextArrow: <SampleNextArrow/>,
        responsive: [
          {
            breakpoint: 1140,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false,
                prevArrow: <></>,
                nextArrow: <></>
              },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              prevArrow: <></>,
              nextArrow: <></>
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              prevArrow: <></>,
              nextArrow: <></>
            }
          }
        ]
      };

    return (
        <div>
            <Slider {...settings}>
                {elements.map((element, index) => (
                    <div key={Math.random()}>{element}</div>
                    ))}
            </Slider>
        </div>
    );
}